import { TeachingHallComment } from '../../../lib/types/models/ol/teaching-hall-comment/teaching-hall-comment'
import { TeachingHallCommentInput } from '../../../lib/types/models/ol/teaching-hall-comment/teaching-hall-comment-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateTeachingHallComment = async (
  data: UpdateInput<TeachingHallCommentInput> & { teachingHallId: number }
) => {
  const { id, teachingHallId, ...rest } = data

  return restApiClient
    .url(
      constructApiUrl(API.teachingHallComments.update.url, {
        commentId: id,
        teachingHallId
      })
    )
    .patch<TeachingHallComment, Partial<TeachingHallCommentInput>>(rest)
}
